import React from "react";

const IconAndTextComponent = (props) => {
    const { Renderer } = props;

    return <Renderer {...props} />;
};

export default IconAndTextComponent;
